export default {
  "brand": "USFansLink",
  "brandSub": "Centre de ressources de la feuille",
  "nav.home": "Accueil",
  "nav.guides": "Guides d'achat",
  "nav.guide": "Guide du débutant",
  "nav.review": "Avis USFans",
  "nav.shipping": "Frais d'expédition",
  "nav.qc": "Guide QC",
  "nav.coupon": "Guide des coupons",
  "nav.warehouse": "Guide de l'entrepôt",
  "nav.legit": "USFans est-il fiable?",
  "buyNow": "Acheter maintenant",
  "exploreSpreadsheet": "Découvrir la feuille USFans",
  "readGuide": "Lire le guide du débutant",
  "language": "Langue",
  "backHome": "Retour à l'accueil",
  "mainSite": "Visiter le site principal",
  "footer.disclaimer": "USFansLink.fun est une ressource informative indépendante. Ce n'est pas le site officiel d'USFans et ne garantit ni vendeurs, produits, prix, services d'expédition ni résultats de transactions. Vérifiez toujours les informations actuelles avant d'acheter.",
  "footer.rights": "Tous droits réservés.",
  "footer.independent": "Ressource indépendante",
  "footer.updated": "Guides actualisés",
  "footer.multilingual": "Support multilingue",
};